import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { inputFields, tables, Buttons, datepicker } from "../../components";

import { UniversityAction } from "../../store/actions";

const Deadlines = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const { universityAdmin, isLoading } = useSelector(
    (state) => state?.university
  );

  const [state, setState] = useState({
    deadlines: [],
  });

  useEffect(() => {
    setState({
      deadlines: universityAdmin?.deadlines ?? [],
    });
  }, [universityAdmin]);

  const handleDeadlineChange = (index, field, value) => {
    const updatedDeadlines = [...state.deadlines];
    updatedDeadlines[index][field] = value;
    setState({ ...state, deadlines: updatedDeadlines });
  };

  const addDeadline = () => {
    const newDeadline = {
      uniID: parseInt(id),
      deadlineType: "",
      appDeadline: "",
      resultType: "",
      resultDate: "",
    };
    setState({
      ...state,
      deadlines: [...state.deadlines, newDeadline],
    });
  };

  const removeDeadline = (index) => {
    const updatedDeadlines = state.deadlines.filter((_, i) => i !== index);
    setState({ ...state, deadlines: updatedDeadlines });
  };

  const handleSubmit = () => {
    const payload = {
      id: parseInt(id),
      page: "deadlines",
      data: state,
    };

    dispatch(
      UniversityAction.editUniversity(payload, () => {
        dispatch(UniversityAction.getUniversityDetailsAdmin(id));
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Deadline type",
      dataIndex: "deadlineType",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleDeadlineChange(index, "deadlineType", e.target.value)
          }
        />
      ),
    },
    {
      title: "Application deadline",
      dataIndex: "appDeadline",
      width: 350,
      render: (text, record, index) => (
        <datepicker.DefaultDatepicker
          datevalue={text}
          onChange={(e, dateString) =>
            handleDeadlineChange(index, "appDeadline", dateString)
          }
        />
      ),
    },
    {
      title: "Result type",
      dataIndex: "resultType",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleDeadlineChange(index, "resultType", e.target.value)
          }
        />
      ),
    },
    {
      title: "Result date",
      dataIndex: "resultDate",
      width: 350,
      render: (text, record, index) => (
        <datepicker.DefaultDatepicker
          datevalue={text}
          onChange={(e, dateString) =>
            handleDeadlineChange(index, "resultDate", dateString)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeDeadline(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.deadlines}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          loading={isLoading}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addDeadline}>
          Add More
        </Buttons.DefaultButton>
        <Buttons.DefaultButton size="medium" onClick={handleSubmit}>
          Save Changes
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Deadlines;
